var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"loading"},[_c('div',[_c('b-spinner',{attrs:{"label":"Loading..."}}),(_vm.text)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }